"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletContext = void 0;
exports.useWallet = useWallet;
var react_1 = require("react");
/**
 * Context for wallet functionality
 */
exports.WalletContext = (0, react_1.createContext)({});
/**
 * Hook for accessing wallet functionality
 *
 * @returns WalletContextState
 */
function useWallet() {
    return (0, react_1.useContext)(exports.WalletContext);
}
